import styles from './Spinner.module.css';

export function Spinner({ size = 'medium' }: { size?: 'small' | 'medium' | 'large' }) {
  const classes = [styles.spinner, size !== 'medium' && styles[size]].filter(Boolean).join(' ');
  return <span className={classes} aria-hidden="true" />;
}

export function PageSpinner({ label = 'Loading' }: { label?: string }) {
  return (
    <div className={styles.page} role="status">
      <Spinner size="large" />
      <span className="visually-hidden">{label}</span>
    </div>
  );
}
